var map = {
	"./Bollywood Night - 11 - 1080_1080.webp": 797,
	"./Celebrity Live Concert - 3 - 1080_1080.webp": 4596,
	"./College Concert - 7 - 1080_1080.webp": 9618,
	"./Concert - 1 - 1080_1080.webp": 2793,
	"./Concert Banner - 2 - 1920_1080.webp": 671,
	"./Corporate Concert Night - 5 - 1080_1080.webp": 4320,
	"./DJ Party - 13 - 1080_1080.webp": 684,
	"./New Year Party - 7 - 1080_1080.webp": 6720,
	"./Why Choose Panthi Event - 11 - 1280_360.webp": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5227;